import { render, staticRenderFns } from "./UcContractPaymentTermsEditor.yaml?vue&type=template&id=4188989d&component"
import script from "./UcContractPaymentTermsEditor.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractPaymentTermsEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports